module.exports = __webpack_public_path__ + "img/2020-05-12.0f0e5a4b.jpg";